import React from 'react';
import HistoryTableHeader from './historyTableHeader';
import { WebViewerServersTableColumnCaptions } from './tableColumnCaptions';

const WebViewerServerHistoryTableHeader = (props) => {
  const { editedFields, objectData } = props;

  const title = [{
    title: WebViewerServersTableColumnCaptions.key,
    value: objectData ? objectData.key : '',
  }];

  return <HistoryTableHeader editedFields={editedFields} captions={WebViewerServersTableColumnCaptions} objectData={objectData} title={title}/>
};

export default WebViewerServerHistoryTableHeader;


// WEBPACK FOOTER //
// ./src/components/webViewerServerHistoryTableHeader.js